import { laptop } from "../../app/breakpoints";
import "./style.css";

export default class TechnologyPage {
  static selector = ".technology-page";

  constructor(block) {
    this.block = block;
    this.isSwitchingDeviceType = false;
  }

  isTouchMode = () =>
    window.innerWidth < laptop ||
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0;

  onReady() {
    this.block.classList.add("technology-page--ready");
    if (this.isTouchMode()) {
      this.block.classList.add("technology-page--touch");
    } else {
      this.block.classList.remove("technology-page--touch");
    }
  }

  onResize() {
    if (this.isTouchMode()) {
      this.block.classList.add("technology-page--touch");
    } else {
      this.block.classList.remove("technology-page--touch");
    }

    if (!this.isSwitchingDeviceType) {
      const urlParams = new URLSearchParams(window.location.search);
      const technologyFirstLevel = urlParams.get("technology_first_level");

      if (technologyFirstLevel === "none" && !this.isTouchMode()) {
        // is desktop and title bar is visible
        this.isSwitchingDeviceType = true;
        window.location.href = "/technologies";
      }
    }
  }

  onComplete() {
    if (!this.isSwitchingDeviceType) {
      const urlParams = new URLSearchParams(window.location.search);
      const technologyFirstLevel = urlParams.get("technology_first_level");

      if (technologyFirstLevel === "none" && !this.isTouchMode()) {
        // is desktop and title bar is visible
        this.isSwitchingDeviceType = true;
        window.location.href = "/technologies";
      }
    }
  }

  onDestroy() {}
}
